import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import resolveWithEnglishFallback from '../../../../utils/i18n-fallback';

const ExperienceCatalogItem = ({
  className = '',
  image,
  titleKey,
  textKey,
  dateKey,
  event,
  linkRole,
}) => {
  const { i18n } = useTranslation();
  const rolePath = linkRole || 'hac';
  const itemClassName = ['experience-catalog-item', className].filter(Boolean).join(' ');

  return (
    <li className={itemClassName}>
      <div className="experience-catalog-item__media">
        <img className="experience-catalog-item__image" src={image} alt="" />
      </div>
      <p className="experience-catalog-item__copy">
        <strong className="experience-catalog-item__title">{resolveWithEnglishFallback(i18n, titleKey)}</strong>
        {dateKey && <strong className="experience-catalog-item__date">{resolveWithEnglishFallback(i18n, dateKey)}</strong>}
        <span className="experience-catalog-item__text">{resolveWithEnglishFallback(i18n, textKey)}</span>
      </p>
      <p className="experience-catalog-item__action">
        <Link
          to={`/${rolePath}/experience?event=${encodeURIComponent(event)}`}
          state={{ event }}
          className="link experience-catalog-item__link"
        >
          <span className="icon-chevron-right experience-catalog-item__link-icon"></span>{' '}
          <span className="experience-catalog-item__link-text">{resolveWithEnglishFallback(i18n, 'experiences-catalog-cta')}</span>
        </Link>
      </p>
    </li>
  );
};

export default ExperienceCatalogItem;
